import React from 'react';
import { ReactComponent as MagicIcon } from 'assets/images/magic.svg';
import styles from './AIProcessingIllustration.module.scss';

const AIProcessingIllustration = () => (
  <div className={styles.container}>
    <div className={styles.mainIcon}>
      <div className={styles.brain}>
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20 25C20 15 28 7 38 7C42 7 45.5 8.5 48 11C50.5 8.5 54 7 58 7C68 7 76 15 76 25C76 30 74 34.5 70.5 37.5C74 40.5 76 45 76 50C76 60 68 68 58 68H38C28 68 20 60 20 50C20 45 22 40.5 25.5 37.5C22 34.5 20 30 20 25Z"
            fill="url(#brainGradient)"
            stroke="#6366f1"
            strokeWidth="2"
          />
          <defs>
            <linearGradient id="brainGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#8b5cf6" />
              <stop offset="100%" stopColor="#6366f1" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <div className={styles.sparkle1}>
        <MagicIcon />
      </div>
      <div className={styles.sparkle2}>
        <MagicIcon />
      </div>
      <div className={styles.sparkle3}>
        <MagicIcon />
      </div>
      <div className={styles.sparkle4}>
        <MagicIcon />
      </div>
      <div className={styles.sparkle5}>
        <MagicIcon />
      </div>
    </div>

    <div className={styles.waves}>
      <div className={styles.wave1} />
      <div className={styles.wave2} />
      <div className={styles.wave3} />
    </div>
  </div>
);

export default AIProcessingIllustration;
